import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { FileText } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

// These pages pull react-markdown + micromark (~156 KB). Keeping them lazy is
// what stops a markdown engine from loading on every session.
const DocsListPage = lazy(() =>
  import('./pages/DocsListPage').then((m) => ({ default: m.DocsListPage })),
)
const DocViewerPage = lazy(() =>
  import('./pages/DocViewerPage').then((m) => ({ default: m.DocViewerPage })),
)

const feature: FrontendFeature = {
  navItems: [
    { path: '/docs', label: 'Docs', icon: FileText },
  ],
  routes: [
    <Route
      key="docs-list"
      path="/docs"
      element={
        <ProtectedRoute>{lazyRoute(<DocsListPage />)}</ProtectedRoute>
      }
    />,
    <Route
      key="docs-view"
      path="/docs/:slug"
      element={
        <ProtectedRoute>{lazyRoute(<DocViewerPage />)}</ProtectedRoute>
      }
    />,
  ],
}

export default feature
